<template>
  <div class="high-water">
    <div class="high-water-item" v-for="(item, index) in deviceInfo" :key="item.deviceId">
      <!-- deviceInfo -->
      <div class="list-content">
        <div class="list-top">
          <div :class="['chart_' + index, 'chart']"></div>
          <div class="chart-right">
            <div v-for="(a, indexs) in alList" :key="a" class="chart-lever">
              <span :style="{ background: getColor(indexs, item) }"> </span>
              {{ a }}
            </div>
            <div class="chart-num" v-if="item.currentValue">
              {{ item.currentValue }} (m)
              <!-- {{
                (Number(item.currentValue * 100) / Number(item.waterLevel * 100)).toFixed(
                  6
                ) * 10000
              }} -->
            </div>
          </div>
        </div>
        <div class="list-title">{{ item.deviceName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    deviceInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      alList: ["AHH", "AH", "AL", "ALL"],
      chart: {},
    };
  },
  mounted() {
    this.init();
    window.onresize = function () {
      for (key in this.chart) {
        this.charts[key].resize();
      }
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    getColor(index, item) {
      if (!item.currentValue) {
        return;
      }
      let colorList = [
        item.hhighWaterThreshold,
        item.highWaterThreshold,
        item.lowWaterThreshold,
        item.llowWaterThreshold,
      ];
      let testValue = Number(item.currentValue);
      // (Number(item.currentValue * 1000) / Number(item.waterLevel * 1000)).toFixed(6) *
      // 1000;
      if (
        colorList[index] &&
        testValue >= colorList[index].split("-")[0] &&
        testValue < colorList[index].split("-")[1]
      ) {
        return "red";
      }
    },
    init() {
      let list = this.deviceInfo;
      list.forEach((item, index) => {
        let key = "chart_" + index;
        let chartDom = document.querySelector("." + this.className + " ." + key);
        this.chart[key] = echarts.init(chartDom);
        let optionChart = {
          legend: {
            top: 0,
            right: 0,
            textStyle: {
              color: "#91abd9",
            },
            itemGap: 10,
            itemWidth: 12,
            itemHeight: 6,
          },
          grid: {
            bottom: 16,
            containLabel: true,
            left: 0,
            right: 0,
            top: 16,
          },
          tooltip: {
            trigger: "item",
            formatter: (val) => {
              return "占比：" + val.data + "%";
            },
          },
          xAxis: [
            {
              data: ["占比"],
              type: "category",
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: "#92A8D9",
                fontSize: 12,
                show: false,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#1E2537",
                },
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              axisLabel: {
                show: true,
                fontSize: 12,
                fontFamily: "Source Han Sans SC",
                color: "#c3d3f5",
              },

              max: 100,
              min: 0,
              interval: 20, //设置刻度间距
              nameTextStyle: {
                color: "#92A8D9",
                align: "left",
                padding: [0, 0, 0, 0],
                fontSize: 11,
              },
              axisLine: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: "",
              type: "bar",
              barGap: 0,
              barWidth: 14,
              itemStyle: {
                normal: {
                  barBorderRadius: [20, 20, 0, 0],
                  color: "rgba(40, 193, 109, 1)",
                  // color: "rgba(223,142,67, 1)",
                  // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  //   {
                  //     offset: 0,
                  //     // color: "RGB(43, 246, 252, 0.9)",
                  //     color: "RGB(223,142,67)",
                  //   },
                  //   {
                  //     offset: 1,
                  //     // color: "RGB(24, 105, 184, 0.9)",/
                  //     color: "RGB(223,142,67)",
                  //   },
                  // ]),
                },
              },
              showBackground: true,
              backgroundStyle: {
                color: "rgba(170, 170, 170, 0.2)",
              },

              data: [
                Math.round(
                  (Number(item.currentValue) / Number(item.waterLevel)) * 10000
                ) / 100,
              ],
            },
          ],
        };

        this.chart[key].setOption(optionChart);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.high-water {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
  &-item {
    width: 32%;
    // max-width: 400px;
    margin-bottom: 12px;
    background: rgba(232,232,232,1);
    padding: 0 16px 16px;
    margin-right: 2%;
    &:nth-child(3n + 0) {
      margin-right: 0;
    }
    .list-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }
    .list-top {
      position: relative;
      display: flex;
      justify-content: space-around;
      width: 40%;
    }
    .list-title {
      background: #fff;
      // color: #fff;
      width: 85%;
      max-width: 300px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      border-radius: 3px;
      &:hover {
        opacity: 0.8;
      }
    }
    .chart-num {
      position: absolute;
      background: #3e76e6;
      height: 32px;
      width: 70%;
      border-radius: 5px;
      bottom: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      &:hover {
        opacity: 0.8;
      }
    }
    .chart {
      height: 200px;
      width: 80px;
    }
    .chart-right {
      padding: 16px 0;
      margin-left: 20px;
    }
    .chart-lever {
      font-size: 11px;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      // color: #c3d3f5;
      span {
        margin-right: 6px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        display: inline-block;
        background: #4b5566;
      }
    }
  }
}
</style>
